import * as ST from './styled';

type THtmlContentFromApiProps = {
    children: string,
};

const HtmlContentFromApi = ({ children }: THtmlContentFromApiProps): JSX.Element => {
    return (
        <ST.HtmlContentFromApi data-test={'html-content-wrapper'} dangerouslySetInnerHTML={{ __html: children }} />
    );
};

export default HtmlContentFromApi;
